/**
 * OwnershipGuard (AJIP-16.02.004 · WS10)
 * ---------------------------------------------------------------------
 * Per Founder Ruling P-05: no auto-merge of anonymous journeys into
 * authenticated journeys. Cross-user restoration is rejected.
 *
 * A record's ownerRef is an opaque string. Two special cases:
 *   * ownerRef === null              — anonymous record. Restorable only
 *                                       by a caller supplying null.
 *   * ownerRef === '<opaque string>' — bound to that owner. Restorable
 *                                       only by a caller supplying the
 *                                       exact same string.
 *
 * matchesOwner(record, principalRef)
 *   Returns true only when record.ownerRef === principalRef. Any
 *   mismatch → false (caller raises OwnershipError).
 *
 * The Framework never resolves identity itself. Principal references
 * are supplied by the calling application through the PersistenceService
 * public API.
 */
import { OwnershipError } from './PersistenceErrors';

const matchesOwner = (record, principalRef) => {
  if (!record) return false;
  const owner = record.ownerRef === undefined ? null : record.ownerRef;
  const principal = principalRef === undefined ? null : principalRef;
  return owner === principal;
};

const assertOwnership = (record, principalRef) => {
  if (!matchesOwner(record, principalRef)) {
    throw new OwnershipError('Record ownerRef does not match principal', {
      recordOwner: record ? record.ownerRef : undefined,
      principal: principalRef,
    });
  }
  return true;
};

export { matchesOwner, assertOwnership };
